import { gsap } from 'gsap/all'
// import Player from '@vimeo/player';
import '@vimeo/player';

export function postVideoSection(element: Element): void {
  // Video Popup
  const embedButton = element.querySelector('.js-embed') as HTMLButtonElement
  const reparentDiv = document.querySelector('.js-reparent') as HTMLDivElement
  const newDiv = element.querySelector('.js-video-reparent') as HTMLDivElement

  if (reparentDiv) reparentDiv.append(...Array.from(newDiv.childNodes))

  const popupVideoWrapper = reparentDiv.querySelector('.js-video-popup-wrapper') as HTMLVideoElement

  const popupVideo = popupVideoWrapper.querySelector('.js-video-popup') as HTMLVideoElement
  const popupVideoEmbed = popupVideoWrapper.querySelector('.js-video-popup-embed') as HTMLVideoElement
  const popupClose = popupVideoWrapper.querySelector('.js-video-popup-close') as HTMLVideoElement
  let player;
  let htmlVideo
  gsap.set(popupVideo, { autoAlpha: 0, yPercent: 100 })

  embedButton.addEventListener('click', openVideoPopup)
  popupVideoWrapper.addEventListener('click', handleClickOutside)
  popupClose.addEventListener('click', closePopup)

  const embed = popupVideoWrapper.querySelector('#embedVideo');
  embed.addEventListener('click', function (e) {
    player.getPaused().then(function (paused) {
      if (paused) {
        player.play();
      } else {
        player.pause();
      }
    });
  })

  function openVideoPopup(e: Event) {
    e.preventDefault();
    if (window.lenis) window.lenis.stop();
    popupVideoWrapper.classList.add('js-open');

    gsap.to(popupVideo, { duration: 0.5, autoAlpha: 1, yPercent: 0, ease: 'power2.out' });

    window.addEventListener('keyup', handleKeyUp);

    // Get the video URL
    const videoUrl = popupVideoWrapper.dataset.video;

    // Check if it's a Vimeo video URL (simplified check)
    const isVimeo = /vimeo\.com/.test(videoUrl);

    // Clear previous content inside #embedVideo
    const embedVideo = document.getElementById('embedVideo');

    if (isVimeo) {
      // Config Vimeo video
      if (!player) {
        const options = {
          url: videoUrl,
          controls: false,
        };
        player = new Vimeo.Player(embedVideo, options);
      }
      player.play();
    } else {
      // Create and configure <video> element for non-Vimeo videos
      embedVideo.innerHTML = '';
      htmlVideo = document.createElement('video');
      htmlVideo.src = videoUrl;
      htmlVideo.controls = true;
      htmlVideo.autoplay = true;
      htmlVideo.style.width = '100%';
      htmlVideo.style.height = '100%';

      // Append the <video> element to #embedVideo
      embedVideo.appendChild(htmlVideo);
    }
  }

  function closePopup() {
    if (window.lenis) window.lenis.start();

    // Pause the Vimeo player if it exists
    if (player) {
      player.pause();
    }

    // Pause the regular HTML video if it exists
    if (htmlVideo) {
      htmlVideo.pause();
    }

    gsap.to(popupVideo, {
      duration: 0.6,
      autoAlpha: 0,
      yPercent: 100,
      ease: 'expo.out',
      onComplete: () => {
        popupVideoWrapper.classList.remove('js-open');
      }
    });

    window.removeEventListener('keyup', handleKeyUp);
  }


  function handleKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape') return closePopup()
  }

  function handleClickOutside(e: Event) {
    if (e.target === e.currentTarget) closePopup()
  }
}
